import axios from "axios";
import API_BASE_URL from "@/config/api";

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  mutations: {
    SET_LIST(state, data) {
      state.list = data;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },

  actions: {
    // 🟢 Ajouter une dépense
    async add({ dispatch }, expense) {
      await this._vm.$guard.confirmAndExecute({
        message: "Ajouter cette dépense ?",
        action: async () => {
          const record = {
            ...expense,
            date: expense.date || new Date().toISOString().split('T')[0],
            created_at: new Date().toISOString(),
          };
          await axios.post(`${API_BASE_URL}/expenses.php`, record);
          await dispatch("fetch");
        },
      });
    },

    // 🔵 Récupérer toutes les dépenses
    async fetch({ commit }) {
      commit("SET_LOADING", true);
      try {
        const { data } = await axios.get(`${API_BASE_URL}/expenses.php`);
        commit("SET_LIST", data);
      } catch (err) {
        console.error("Erreur fetch expenses:", err);
      }
      commit("SET_LOADING", false);
    },

    // 🟠 Modifier une dépense
    async update({ dispatch }, { id, payload }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Modifier cette dépense ?",
        action: async () => {
          await axios.put(`${API_BASE_URL}/expenses.php`, { id, ...payload });
          await dispatch("fetch");
        },
      });
    },

    // 🔴 Supprimer une dépense
    async remove({ dispatch }, id) {
      await this._vm.$guard.confirmAndExecute({
        message: "Supprimer cette dépense ?",
        action: async () => {
          await axios.delete(`${API_BASE_URL}/expenses.php`, { data: { id } });
          await dispatch("fetch");
        },
      });
    },

    // ⚪ Vider toutes les dépenses
    async clear({ dispatch }) {
      await this._vm.$guard.confirmAndExecute({
        message: "Effacer toutes les dépenses ?",
        action: async () => {
          await axios.post(`${API_BASE_URL}/expenses.php`, { action: "clear" });
          await dispatch("fetch");
        },
      });
    },
  },

  getters: {
    all: (state) => state.list,
    totalAmount: (state) =>
      state.list.reduce((sum, e) => sum + Number(e.amount || 0), 0),
    isLoading: (state) => state.loading,
  },
};
